/*
 * File: Routes.tsx
 * Project: a-a
 * File Created: Thursday, 10th October 2024 8:41:30 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 20th November 2025 11:06:49 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import React, { useEffect } from 'react';
import {
  loader,
  ProtectedRoute,
  ValidateEmailRoute,
  ValidateNewUserRoute,
} from './ProtectedRoutes';
import {
  createBrowserRouter,
  createHashRouter,
  createRoutesFromElements,
  Navigate,
  Route,
  RouterProvider,
} from 'react-router-dom';
import RegisterScreen from '../pages/Register/Register';
import LoginScreen from '../pages/LoginScreen/LoginScreen';
import RoutePaths from './RoutePaths';
import Homepage from '../pages/Dashboard/Homepage/Homepage';
import RegisterForm from '../pages/RegisterForm/RegisterForm';
import EmailVerification from '../pages/EmailVerification/EmailVerification';
import MainLayout from '../layout/layout';
import ForgotPassword from '../pages/ForgotPassword/ForgotPassword';
import ResetPassword from '../pages/ResetPassword/ResetPassword';
import Terms from '../pages/Terms-Privacy/Terms';
import Privacy from '../pages/Terms-Privacy/Privacy';
import Client from '../pages/Dashboard/Client/Client';
import Team from '../pages/Dashboard/Team/Team';
import ClientSelected from '../components/featured/Client/ClientSelected/ClientSelected';
import TeamSelected from '../components/featured/Team/TeamSelected';
import ErrorComponent from '../pages/404/404';
import Asana from '../pages/Asana/Asana';
import AsanaProjectDetails from '../components/featured/Asana/AsanaProjectDetails/AsanaProjectDetails';
import ZoomInfo from '../pages/ZoomInfo/ZoomInfo';
import ZoomInfoSelected from '../components/featured/ZoomInfo/ZoomInfoSelected/ZoomInfoSelected';
const Root = () => {
  // useEffect(() => {
  //   window.location.href = `https://aam-service-infra-dev.auth.us-east-1.amazoncognito.com/logout?response_type=code&client_id=59g9d2ppnccdqda2e64glkl7hm&logout_uri=${process.env.REACT_APP_LOGIN}&redirect_uri=${process.env.REACT_APP_LOGIN}`;
  // }, []);
  return <Navigate to={RoutePaths.Login} />;
};
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' errorElement={<ErrorComponent />}>
      <Route index element={<Root />} />
      <Route path={RoutePaths.Login} element={<LoginScreen />} />
      <Route
        path={RoutePaths.RegisterForm}
        element={
          <ValidateNewUserRoute>
            <RegisterForm />
          </ValidateNewUserRoute>
        }
      />

      <Route path={RoutePaths.EmailVerification} element={<EmailVerification />} />
      <Route path={RoutePaths.Register} element={<RegisterScreen />} />
      <Route path={RoutePaths.ResetPassword} element={<ResetPassword />} />
      <Route path={RoutePaths.ForgotPassword} element={<ForgotPassword />} />
      <Route path={RoutePaths.Terms} element={<Terms />} />
      <Route path={RoutePaths.Privacy} element={<Privacy />} />
      <Route
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
        loader={loader}
      >
        <Route path={RoutePaths.Home} element={<Homepage />} />
        <Route path={RoutePaths.Client} element={<Client />} />

        <Route path={`${RoutePaths.Client}/huddle/:id`} element={<ClientSelected />} />
        <Route path={`${RoutePaths.Client}/:id`} element={<ClientSelected />} />
        <Route path={RoutePaths.Team} element={<Team />} />
        <Route path={`${RoutePaths.Team}/:id`} element={<TeamSelected />} />
        <Route path={RoutePaths.Asana} element={<Asana />} />
        <Route path={`${RoutePaths.Asana}/:id`} element={<AsanaProjectDetails />} />
        <Route path={RoutePaths.ZoomInfo} element={<ZoomInfo />} />
        <Route path={`${RoutePaths.ZoomInfo}/:id`} element={<ZoomInfoSelected />} />
      </Route>
    </Route>,
  ),
);

const Routes = () => {
  return <RouterProvider router={router} />;
};

export default Routes;
